import { FC } from 'react';
import Page from 'src/layout/Page';
import './passwordReset.css';
import { useLocation } from 'react-router-dom';
import { EmailForm } from 'pages/PasswordReset/EmailForm';
import { UpdatePassword } from 'pages/PasswordReset/UpdatePassword';
import { LoaderProvider } from 'src/hooks/useLoader/LoaderContext';

export const PasswordReset: FC = () => {
	const { search } = useLocation();
	const searchParams = new URLSearchParams(search);
	const token = searchParams.get('token');
	return <LoaderProvider>
		<Page>
			{token ?
				<UpdatePassword token={token}/> :
				<EmailForm/>}
		</Page>
	</LoaderProvider>;
};
